import useRequest, { IAlterarStatusRequest, IDataRequest } from '@hooks/useRequest';
import { IPermissao } from '@model/Permissao';
import { IUsuario } from '@model/Usuario';
import IUsuarioStatus, { EnumUsuarioStatus } from '@model/UsuarioStatus';
import React from 'react';

export interface IUsuarioFilter {
    nome?: string
    usuarioStatusId?: EnumUsuarioStatus
}

export interface IResetarSenhaRequest {
    novaSenha: string
    confirmarNovaSenha: string
}

export interface IPermissionResponse {
    allPermissions: IPermissao[]
    userPermissions: number[]
}

const controller = "/Usuario";

export function useUsuarioService () {
    const _request = useRequest();

    const listar = React.useCallback((request: IDataRequest<IUsuarioFilter>) => {
        return _request.getData<IUsuario[]>(`${controller}/Listar`, request);
    }, [_request]);

    const listarStatusAtivos = React.useCallback(() => {
        return _request.get<IUsuarioStatus[]>(`${controller}/ListarStatusAtivos`);
    }, [_request]);

    const registrar = React.useCallback((request: IUsuario) => {
        return _request.post<IUsuario>(`${controller}/Registrar`, request);
    }, [_request]);

    const editar = React.useCallback((usuarioId: number, request: IUsuario) => {
        return _request.post<IUsuario>(`${controller}/Editar/${usuarioId}`, request);
    }, [_request]);

    const alterarStatus = React.useCallback((usuarioId: number, request: IAlterarStatusRequest<EnumUsuarioStatus>) => {
        return _request.post<IUsuario>(`${controller}/AlterarStatus/${usuarioId}`, request);
    }, [_request]);

    const resetarSenha = React.useCallback((usuarioId: number, request: IResetarSenhaRequest) => {
        return _request.post<IUsuario>(`${controller}/ResetarSenha/${usuarioId}`, request);
    }, [_request]);

    const listarInternos = React.useCallback(() => {
        return _request.get<IUsuario[]>(`${controller}/ListarInternos`);
    }, [_request]);

    const listarPermissoes = React.useCallback((usuarioId: number) => {
        return _request.get<IPermissionResponse>(`${controller}/ListarPermissoes/${usuarioId}`);
    }, [_request]);

    return React.useMemo(() => ({
        listar, listarStatusAtivos, registrar, editar, alterarStatus, resetarSenha, listarInternos, listarPermissoes
    }), [listar, listarStatusAtivos, registrar, editar, alterarStatus, resetarSenha, listarInternos, listarPermissoes]);
}